<template>
	<v-tooltip bottom v-if="$store.getters.checkModulePermissions('crm')">
		<template v-slot:activator="{ on }">
			<v-btn v-on="on" icon class="ml-2" @click="setColorMode()">
				<v-icon :class="$eventBusUtility.iconAppBarColor" light v-on="on">{{$vuetify.theme.dark ? 'mdi-brightness-5' : 'nights_stay'}}</v-icon>
			</v-btn>
		</template>	
		<span>{{ $vuetify.theme.dark ? 'Light': 'Dark'}} Mode</span>
	</v-tooltip>
</template>

<script>
    export default {
        name: 'color-mode',
        data() {
            return {
                colorMode: this.$vuetify.theme.dark
            }
        },

        methods: {
            setColorMode() {
                this.$vuetify.theme.dark = !this.$vuetify.theme.dark
                localStorage.setItem('colorMode', this.$vuetify.theme.dark)
                this.$emit('colorModeChanged', this.$vuetify.theme.dark)
            },
        }
    }
</script>
